import ignite from '../../services/ignite';
import getLogger from '@ignitesales/logger-es';

const logger = getLogger({ module: 'analytics-action-creators' });

const IgniteCommonActions = {
  APPOINTMENT_BUTTON_CLICKED: 'makeAppointmentClicked',
  CART_PRODUCT_ADDED: 'addToCartClicked',
  CONTACT_FORM_CLICKED: 'contactMeClicked',
  LANGUAGE_CHANGED: 'languageChangeClicked',
  LOCATION_BRANCH_CLICKED: 'locateBranchClicked',
  PHONE_NUMBER_CLICKED: 'phoneNumberClicked',
  PRINT_BUTTON_CLICKED: 'printButtonClicked',
  PRODUCT_APPLY_CLICKED: 'productApplyClicked',
  PRODUCT_APPOINTMENT_CLICKED: 'productAppointmentClicked',
  PRODUCT_DETAILS_CLICKED: 'productDetailsClicked',
  SAVE_PRODUCT_FOR_LATER: 'saveForLaterClicked',
  SHARE_VIA_EMAIL_CLICKED: 'shareViaEmailClicked',
  SHARE_VIA_SMS_CLICKED: 'shareViaSmsClicked',
  VIEW_ANSWERS_BUTTON_CLICKED: 'answerDetailsClicked',
  VIEW_CART_BUTTON_CLICKED: 'viewCartButtonClicked',
  VIEW_DETAILS_PAGE_CLICKED: 'printFormClicked'
};

const triggerIgniteAction = ({ actionName, append = false, productId, value = 'completed'}) => {
  return async () => {
    try {
      await ignite.answerService.actionCompleted({
        appkey: actionName,
        value,
        productId,
        append,
      });
    } catch (ex) {
      logger.error('Error while triggering analytics action', ex);
    }
  };
};

export {
  triggerIgniteAction,
  IgniteCommonActions
};
